import React from 'react';

class XpressTemplateView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      viewOriginal: false,
    };
    this.handleToggleViewOriginal = this.handleToggleViewOriginal.bind(this);
  }

  handleToggleViewOriginal() {
    this.setState({ viewOriginal: !this.state.viewOriginal });
  }

  render() {
    let { template } = this.props;
    let { viewOriginal } = this.state;

    return (
      <div>
        <h2>{template.name}</h2>
        <h3 style={{ textAlign: 'center' }}>{template.description}</h3>

        <h4>Kiosk</h4>
        <table className='pure-table'>
          <thead>
            <tr>
              <td>#</td>
              <td>Name</td>
              <td>Value</td>
            </tr>
          </thead>
          <tbody>
            {template.xTemplateItems
              .filter((item) => /kiosk/i.test(item.tableName))
              .map((item, count) => {
                return (
                  <tr key={item.id}>
                    <td>{count + 1}</td>
                    <td>{item.name}</td>
                    <td>{item.value}</td>
                  </tr>
                );
              })}
          </tbody>
        </table>

        <h4>SfeCfg (ksk)</h4>
        <div style={{ textAlign: 'right', marginTop: '-10px' }}>
          <a href='javascript:void(0)' onClick={this.handleToggleViewOriginal}>
            show/hide original data
          </a>
        </div>
        <table className='pure-table'>
          <thead>
            <tr>
              <td>#</td>
              <td>Name</td>
              <td>Value</td>
            </tr>
          </thead>
          <tbody>
            {template.xTemplateItems
              .filter((item) => /ksk/i.test(item.cfgType))
              .map((item, count) => {
                let dicRule = findDicRule(template.dicRules, item);
                return (
                  <tr key={item.id}>
                    <td>{count + 1}</td>
                    <td>
                      {dicRule.label}
                      {viewOriginal && (
                        <div style={{ fontSize: 10, color: '#555' }}>{item.type}</div>
                      )}
                    </td>
                    <td>
                      {findDicRuleValueText(dicRule.choices, item.value)}
                      {viewOriginal && (
                        <div style={{ fontSize: 10, color: '#555' }}>{item.value}</div>
                      )}
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>
    );
  }
}

function findDicRule(dicRules, item) {
  let dicRule = dicRules.find((d) => {
    let itemType = item.type ? item.type.toLowerCase() : '';
    let dicruleName = d.name ? d.name.toLowerCase() : '';
    let isKskCfgType = /ksk/i.test(item.cfgType);
    let isKskDicRuleType = /ksk/i.test(d.type);
    return isKskCfgType && isKskDicRuleType && itemType === dicruleName;
  });
  return dicRule || {};
}

function findDicRuleValueText(choices, value) {
  choices = /null/i.test(choices) ? '{}' : choices;
  try {
    choices = choices.replace(/'/g, '"');
    let o = JSON.parse(choices);
    return o[value] || value;
  } catch (e) {
    console.warn('failed to parse value:', value, 'for choices:', choices);
  }
  return value;
}

export default XpressTemplateView;



// WEBPACK FOOTER //
// ./src/components/XpressTemplateView.js